import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AssociationTypesEnum } from '../enums/association-types.enum';
import { map, Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserFactory } from '../../store/price.model';
import { Role } from '../../store/shared.model';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {
  private http = inject(HttpClient);

  constructor() {}

  getRoles(associationType: AssociationTypesEnum): Observable<Role[]> {
    return this.http.get<Role[]>(`${environment.AGTRACE_API}v1/roles?associationType=${associationType}`);
  }

  getUserFactories(factoryCode: string): Observable<UserFactory[]> {
    return this.http.get<UserFactory[]>(`${environment.AGTRACE_API}v1/user/factory?factoryCode=${factoryCode}`);
  }
}
